// extracted by mini-css-extract-plugin
module.exports = {"container":"authorization_container__3SJR-","iconsContainer":"authorization_iconsContainer__1vuza","selectflex":"authorization_selectflex__nESN4"};